import React from "react";
import { useSelector } from "react-redux";
import { getIndexCampaigns } from "../../../store/indexCampaigns/selectors.js";
import Frame from "../Frame/Frame.js";
import Container from "../Container/index.js";
import { FlightCampaignTCBanner } from ".//index.js";
export function GeniusFlightsHomeBanner() {
    const { genius: geniusCampaign } = useSelector(getIndexCampaigns);
    if (!geniusCampaign) {
        return null;
    }
    return (React.createElement(Container, null,
        React.createElement(Frame, { mt: 6, mb: 8 },
            React.createElement(FlightCampaignTCBanner, { campaignBanner: geniusCampaign }))));
}
